@let membership = service.membership();
@let next_transaction = membership?.next_transaction;
@let recurs = membership?.recurs;
@let base_price = membership?.base_price;
@let current_price = membership?.final_price;
@let expiry = membership?.expiry;
@let base_plans = ['free','traveller_free','yearly', 'monthly'].includes(package_slug());

@if(!otherPlans()){
    <h2 class="page-title">Your current subscription</h2>
    <div class="subscription" paint="plan-bg" [ngClass]="package_slug()">
        <div class="header">
            <div class="header-plan">
                <h3 class="m-0 plan">
                    {{package().name}}
                </h3>
                <!-- <h3 class="m-0 package" bold>cloudigo Discounts</h3> -->
                <!-- <h3 class="m-0 plan" [ngSwitch]="level">
                    <ng-container *ngSwitchCase="3">Premium Yearly Plan</ng-container>
                    <ng-container *ngSwitchCase="1">Premium Monthly Plan</ng-container>
                    <ng-container *ngSwitchDefault>Free Plan</ng-container>
                </h3> -->
            </div>
            <div class="header-pricing">
                @if(expiry){
                    <h4 class="m-0">{{recurs || next_transaction ? 'Renewal' : 'Expiry'}} date:</h4>
                    <h4 class="m-0" bold>{{expiry ? (expiry | date: 'd/M/yyyy') : 'Indefinite'}}</h4>
                }
            </div>
        </div>
        @if(!package_tags().includes('free')){
            <div class="current-billing">
                <h2 class="m-0 font-bold">
                    {{base_price == '0.00' ? 'FREE' : ('€'+base_price)}} 
                    @if(package().package_type == 'corporate' && !package().limited){
                        indefinitely
                    } @else {
                        {{recurs ? '/' : ('for ' + package().duration)}} 
                        {{package().unit || 'year'}}{{!recurs && package().duration != 1 ? 's' : ''}}
                    }
                </h2>
                @if(base_plans){
                    <h4 class="m-0">
                        Current plan billed at €{{current_price}}
                    </h4>
                }
                @if(recurs && next_plan_text()){
                    <h3 class="m-0 font-semibold" routerLink="/profile/codes" style="outline: 0;">
                        {{next_plan_text()}}
                    </h3>
                }
    
                @if(package().recurs && expiry && ((next_package_slug() && next_package_slug() != package_slug()) || !recurs)){
                    <br/>
                    <h4 class="m-0 font-light">
                        You will be {{next_transaction ? 'upgraded' : 'downgraded'}} to the {{next_package().name || 'Free Plan'}} at the end of your membership.
                    </h4>
                }
            </div>
        }
        <div class="content">
            @if(!package_tags().includes('free')){
                <p class="m-0" paint="light">
                    @if(package().recurs){
                        @if(recurs){
                            Your subscription will be automatically renewed as per <a paint="light" routerLink="/terms-and-conditions">Terms & Conditions</a>. You can cancel your subscription anytime by clicking below
                        } @else if(expiry){
                            You can resubscribe to the same or different plan by clicking the button below
                        } @else {
                            Your subscription has no defined end date! Enjoy!
                        }
                    } @else if(expiry){
                        Your subscription will end on the expiry date
                    } @else {
                        Your subscription is managed by your provider and currently has no defined end date! Enjoy!
                    }
                </p>
            } @else {
                <p class="m-0">
                    You're missing out on unlimited and even higher discounts on fashion, food & more. Click on the below button learn about our Premium Plans.
                </p>
            }
        </div>
        @if(base_plans){
            <div class="footer">
                @if (!package_tags().includes('free')){
                    <button (click)="otherPlans.set(!otherPlans());" mat-stroked-button paint="warn">Change Plan</button>
                } @else if(package_tags().includes('tourist')) {
                    <a mat-raised-button class="mat-elevation-z1 accent-horizontal" [routerLink]="['/traveller']">Get Traveller</a>
                } @else {
                    <a mat-raised-button class="mat-elevation-z1 premium-horizontal" [routerLink]="['/premium']">Get Premium</a>

                }
            </div>
        }
        
    </div>
} @else {
    <!-- PLAN BROWSER -->
    <h2 class="page-title">
        Our Plans
        <div style="float: right;">
            <span (click)="otherPlans.set(!otherPlans());" class="my-plan" paint="plan-bg">View My Plan</span>
        </div>

    </h2>
    <div class="other-plans">
        <div class="other-plan" paint="warn" [class.current]="package_slug() == 'yearly'">
            <h3 class="m-0 plan-name font-bold painted">
                Premium Yearly Plan
            </h3>
            <h4 class="m-0 plan-price painted">
                <span class="font-bold">€49.99</span><small> / year</small>
            </h4>
    
            <div class="plan-content">
                <p class="m-0 painted">
                    Access to unlimited discounts, 2 for 1 offers and discounts up to 50% OFF
                </p>
            </div>

            <div class="plan-button">

                @if(package_slug() == 'yearly'){
                    @if(next_package_slug() == 'monthly'){
                        <button class="plan-cta premium-horizontal" mat-raised-button (click)="toggleRenewal(true)">Switch to Premium Yearly</button>
                    } @else {
                        @if(recurs){
                            <button class="plan-cta painted" mat-stroked-button [disabled]="true">Current Plan</button>
                        } @else {
                            <button class="plan-cta premium-horizontal" mat-raised-button (click)="toggleRenewal(true)" [disabled]="!expiry">Resubscribe to Yearly</button>
                        }
                    }
                } @else {
                    @if(next_transaction){
                        <button class="plan-cta painted" [disabled]="true" mat-stroked-button>Next Plan (Paid)</button>
                    } @else {
                        <a class="plan-cta premium-horizontal" [routerLink]="['/premium']" mat-raised-button>Get Premium Yearly</a>
                    }
                }
            </div>
        </div>

        @if(package_slug() == 'monthly'){
            <div class="other-plan monthly" paint="warn">
                <h3 class="m-0 plan-name" paint="warn" bold>
                    Premium Monthly Plan
                </h3>
                <h4 class="m-0 plan-price" paint="warn">
                    <span bold>€4.99</span><small> / month</small>
                </h4>
        
                <div class="plan-content">
                    <p class="m-0" paint="warn">
                        Access to unlimited discounts, 2 for 1 offers and discounts up to 50% OFF
                    </p>
                </div>
                
                <div class="plan-button">
                    @if(recurs){
                        <button class="plan-cta" paint="warn" mat-stroked-button [disabled]="true">Current Plan</button>
                    } @else {
                        <button class="plan-cta premium-horizontal" mat-raised-button (click)="toggleRenewal(true)">Resubscribe</button>
                    }
                    
                </div>
            </div>
        }

        <div class="other-plan free" paint="primary" [class.current]="package_slug() == 'free'">
            <h3 class="m-0 plan-name font-bold" paint="primary">
                Free Plan
            </h3>
            <h4 class="m-0 plan-price" paint="primary">
                <!-- <span bold>€4.99</span><small> / month</small> -->
                &nbsp;
            </h4>
    
            <div class="plan-content">
                <p class="m-0" paint="primary">
                    Switching to Free will cancel your Premium Plan. By switching to Free, you will only have a small one-time discount from each brand.
                </p>
            </div>

            <div class="plan-button">
                @if(!package_tags().includes('free')){
                    @if(recurs && expiry){
                        <button class="plan-cta" paint="primary" mat-stroked-button (click)="toggleRenewal(false)">Cancel Subscription</button>
                    } @else {
                        <button class="plan-cta" paint="primary" mat-stroked-button [disabled]="true">Next Plan</button>
                    }
                } @else if(!recurs) {
                    <button class="plan-cta" paint="primary" mat-stroked-button [disabled]="true">Current Plan</button>
                }
            </div>
        </div>
    </div>
}